export const getAutomations = state => state.automations;